import React from 'react';
import { Row, Column } from 'components/Layout/Grid';
import Text from 'components/Text';
import Animated from 'components/Animated';
import { ISliderMessageProps } from './interface';

const SliderMessage: React.FC<ISliderMessageProps> = (props) => {
  const { show, message } = props;

  return (
    <Animated
      show={!!show}
      animationIn="slideInDown"
      animationInDelay="faster"
      animationOut="slideOutUp"
      animationOutDelay="faster"
      className="fixed top-0 right-0 bottom-0 bg-white d-flex w-100 flex-lg-column align-center justify-center}"
      style={{ height: 50, zIndex: 999999999999 }}
    >
      <Row
        className="flex-1"
        style={{
          background: '#0E4C54',
          height: '100%',
        }}
      >
        <Column className="flex-1 p-1">
          <Text size={24} className="color-white font-bold w-100 text-center">
            {message}
          </Text>
        </Column>
      </Row>
    </Animated>
  );
};

export default SliderMessage;
